const Emergency = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-emergency-cap"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-emergency-cap"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="m21,18.126v-5.126c0-4.963-4.037-9-9-9S3,8.037,3,13v5.126c-1.724.445-3,2.013-3,3.874,0,1.103.897,2,2,2h20c1.103,0,2-.897,2-2,0-1.861-1.276-3.429-3-3.874ZM12,6c3.859,0,7,3.141,7,7v5H5v-5c0-3.859,3.141-7,7-7ZM2,22c0-1.103.897-2,2-2h16c1.103,0,2,.897,2,2H2ZM20.797,6.211c-.393-.389-.396-1.021-.008-1.414l1.5-1.517c.388-.393,1.021-.396,1.414-.008.393.389.396,1.021.008,1.414l-1.5,1.517c-.195.198-.453.297-.711.297-.254,0-.508-.097-.703-.289Zm-4.185-4.171l.777-1.5c.254-.492.859-.682,1.348-.428.49.254.682.857.428,1.348l-.777,1.5c-.178.344-.527.54-.889.54-.155,0-.312-.036-.459-.112-.49-.254-.682-.857-.428-1.348ZM.289,4.687c-.389-.393-.385-1.025.008-1.414.392-.389,1.027-.385,1.414.008l1.5,1.517c.389.393.385,1.025-.008,1.414-.194.192-.449.289-.703.289-.258,0-.516-.099-.711-.297l-1.5-1.517ZM4.835,1.46c-.254-.49-.062-1.094.428-1.348.487-.254,1.093-.064,1.348.428l.777,1.5c.254.49.062,1.094-.428,1.348-.146.076-.304.112-.459.112-.361,0-.711-.196-.889-.54l-.777-1.5Zm3.165,11.54c0-2.206,1.794-4,4-4,.553,0,1,.447,1,1s-.447,1-1,1c-1.103,0-2,.897-2,2,0,.553-.447,1-1,1s-1-.447-1-1Z" />
    </svg>
  );
};

export default Emergency;
